module.exports = __webpack_public_path__ + "img/16.db05c86f.jpg";